import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    maxWidth: 800,
    mx: 'auto',
    mt: 4,
  },
  mainAddressBox: {
    p: 2,
    mb: 4,
    backgroundColor: 'rgba(76,175,80,0.1)',
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    mt: 4,
  },
  addressItem: {
    p: 2,
    position: 'relative',
  },
};
